<script>
import 'bulma/css/bulma.css'
import { removeUrl, removeHtml, formatDate, reduceMsg, addUrlInNoMsg } from '@/api/Utilities.js'
import { updateCardMarker, deleteCard } from '@/api/FirebaseBoardWrapper.js'
import { updateCloneCard } from '@/api/FirebaseTreesWrapper.js'
import modalWindow from '@/components/ModalWindow'
import * as constant from '@/constant/constant.js'

require('@/css/style.css')

export default {
  props: [
    'card',
    'x',
    'y',
    'w',
    'h',
    'marginX',
    'marginY',
    'teamId',
    'clickedCardId'
  ],
  components: {
    modalWindow
  },
  data () {
    return {
      Q_LENGTH: 1000,
      userId: this.card.userId,
      cardId: this.card.id,
      color: this.card.marker,
      msg: this.card.question,
      nodeClass: 'node',
      paletteClass: 'is-dark',
      deleteClass: 'is-dark',
      isMarkerActive: false,
      enableDelModal: false,
      selectColor: this.card.marker,
      cardLimit: constant.DEFAULT_CARD_LIMIT
    }
  },
  async created () {
    await this.renderCard()
  },
  watch: {
    card: {
      handler: async function (val) {
        await this.renderCard()
      },
      deep: true
    },
    clickedCardId: function (val) {
      if (this.clickedCardId !== this.card.id) {
        this.isMarkerActive = false
      }
    }
  },
  methods: {
    async renderCard () {
      this.userId = this.card.userId
      this.cardId = this.card.cloneCardId
      this.color = this.card.marker
      this.selectColor = this.color
      this.msg = this.card.question
      this.editMsg = removeHtml(this.card.question)
      this.msg = removeHtml(this.msg)
      this.msg = removeUrl(this.msg)
      this.msg = reduceMsg(this.msg, this.cardLimit)
      this.msg = addUrlInNoMsg(this.msg)
      // 初期化
      if (this.color === 'important') {
        this.nodeClass = 'nodeImportant'
      } else if (this.color === 'thinking') {
        this.nodeClass = 'nodeThinking'
      } else {
        this.nodeClass = 'node'
      }
    },
    clickCard () {
      this.isMarkerActive = false
      this.$emit('clickCard', this.card.id)
    },
    clickPaletteButton () {
      this.isMarkerActive = !this.isMarkerActive
    },
    async clickColorButton (marker = undefined) {
      this.isMarkerActive = false
      if (marker) {
        try {
          await updateCardMarker(this.teamId, this.card.id, marker)
          this.color = marker
          this.selectColor = marker
        } catch (err) {
          // 失敗したらやり直し
          this.isMarkerActive = !this.isMarkerActive
        }
      }
    },
    clickEditButton () {
      this.$emit('enableEditCard', true, this.card.id)
    },
    clickDeleteButton () {
      this.enableDelModal = true
    },
    async doDelete () {
      try {
        await deleteCard(this.card.id, this.teamId)
        if (this.card.treeId) {
          // nodeのcloneCardIdもnullに戻す
          await updateCloneCard(this.card.treeId, this.card.nodeId, null)
        }
        this.enableDelModal = false
      } catch (err) {
        console.log(err)
      }
    },
    closeDelModal () {
      this.enableDelModal = false
    }
  },
  filters: {
    timestampToDate: function (firebaseTimestamp) {
      if (!firebaseTimestamp || firebaseTimestamp.hasOwnProperty('toDate')) {
        return
      }
      return formatDate(firebaseTimestamp.toDate(), 'MM/dd HH:mm')
    }
  }
}
</script>
<style scoped>
.button.is-dark {
  background-color: #A9A9A9;
  border-color: transparent;
  color: whitesmoke;
}
.button.is-link {
  background-color: #96c3fa;
  border-color: transparent;
  color: #fff;
}
.button.is-danger {
  background-color: #ffaac8;
  border-color: transparent;
  color: #fff;
}
.button.is-warning {
  background-color: #fffa8c;
  border-color: transparent;
  color: #fff;
}
.button.is-success {
  background-color: #96ffc8;
  border-color: transparent;
  color: #fff;
}
.node {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(60, 100%, 85%, 1) 0.5rem, hsla(60, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(60, 100%, 85%, 0.2), hsla(60, 100%, 85%, 0.2));
}
.nodeImportant {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(100, 100%, 85%, 1) 0.5rem, hsla(100, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(100, 100%, 85%, 0.2), hsla(100, 100%, 85%, 0.2));
}
.nodeThinking {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(15, 100%, 85%, 0.6) 0.5rem, hsla(15, 100%, 85%, 0.3) 0.75rem),
  linear-gradient(180deg, hsla(15, 100%, 85%, 0.2), hsla(15, 100%, 85%, 0.2));
}
.button {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  position: absolute;
}
.button.large {
  width: 30px !important;
  height: 30px !important;
}
.button-icon {
  background-color: white;
  border-color: #dbdbdb;
  border-width: 1px;
  border-radius: 4px;
  color: #363636;
  cursor: pointer;
  justify-content: center;
  padding-bottom: calc(0.5em - 1px);
  padding-left: 1em;
  padding-right: 1em;
  padding-top: calc(0.5em - 1px);
  text-align: center;
  white-space: nowrap;
}
.button-icon.is-link {
  background-color: #485fc7;
  border-color: transparent;
  color: #fff;
}
.button-icon.is-link:hover, .button-icon.is-link.is-hovered {
  background-color: #3e56c4;
  border-color: transparent;
  color: #fff;
}
.button-icon.is-link:focus, .button.is-link.is-focused {
  border-color: transparent;
  color: #fff;
}
.card-foot {
  padding-bottom: 20px;
}
</style>
<template>
<div>
  <!-- Node -->
  <div :class="nodeClass" :style="{left:x - w/2 + 'px', top:y + 'px', width:w - marginX + 'px', height:h - marginY + 'px'}" @click="clickCard()">
    <span>{{this.msg}}</span>
  </div>
  <!-- colorボタン -->
  <a class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless" :class="paletteClass"  :style="{left:x - w/2 + 1.8*marginX + 'px', top:y - marginY/3 + 'px'}"  @click="clickPaletteButton()">
    <span class="icon is-small"><i class="fa-solid fa-palette" aria-hidden="true"></i></span>
  </a>
  <!-- colorボタン赤 -->
  <a v-if="isMarkerActive" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless is-danger" :style="{left:x - w/2 + 1.8*marginX + 'px', top:y - 8*marginY/5+ 'px'}"  @click="clickColorButton('thinking')">
    <span class="icon is-small"><i class="fa-solid fa-palette" aria-hidden="true"></i></span>
  </a>
  <!-- colorボタン黄 -->
  <a v-if="isMarkerActive" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless is-warning" :style="{left:x - w/2 + 3.0*marginX + 'px', top:y - 8*marginY/5 + 'px'}"  @click="clickColorButton('soso')">
    <span class="icon is-small"><i class="fa-solid fa-palette" aria-hidden="true"></i></span>
  </a>
  <!-- colorボタン緑 -->
  <a v-if="isMarkerActive" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless is-success" :style="{left:x - w/2 + 4.2*marginX + 'px', top:y - 8*marginY/5 + 'px'}"  @click="clickColorButton('important')">
    <span class="icon is-small"><i class="fa-solid fa-palette" aria-hidden="true"></i></span>
  </a>
  <!-- 編集ボタン -->
  <a class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless" :class="deleteClass" :style="{left:x - w/2 + 3.0*marginX + 'px', top:y - marginY/3 + 'px'}" @click="clickEditButton()">
    <span class="icon is-small"><i class="fa-solid fa-pen" aria-hidden="true"></i></span>
  </a>
  <!-- 削除ボタン -->
  <a class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless" :class="deleteClass" :style="{left:x - w/2 + 4.2*marginX + 'px', top:y - marginY/3 + 'px'}" @click="clickDeleteButton()">
    <span class="icon is-small"><i class="fa-solid fa-trash" aria-hidden="true"></i></span>
  </a>
  <div class="delete-modal">
    <modalWindow @close="closeDelModal" v-if="enableDelModal">
      <template slot="header">
        <div class="buttons is-right">
          <button class="delete" @click="closeDelModal"></button>
        </div>
      </template>
      <p>このカードを削除しますか？</p>
      <template slot="footer">
        <div class="card-foot">
          <div class="buttons is-centered">
            <button class="button-icon" @click="closeDelModal">キャンセル</button>
            &nbsp;
            &nbsp;
            &nbsp;
            <button class="button-icon is-link" @click="doDelete()">削除</button>
          </div>
        </div>
      </template>
    </modalWindow>
  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/board/Card.vue